const IMAGE_EXTS = ['jpg', 'jpeg', 'png', 'gif', 'webp'];

export function getFileExtension(filename: string): string {
  return filename.split('.').pop()?.toLowerCase() ?? '';
}

export function isImageFilename(filename: string): boolean {
  return IMAGE_EXTS.includes(getFileExtension(filename));
}

export function isPdfFilename(filename: string): boolean {
  return getFileExtension(filename) === 'pdf';
}

const CONTENT_TYPE_BY_EXT: Record<string, string> = {
  pdf: 'application/pdf',
  png: 'image/png',
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  gif: 'image/gif',
  webp: 'image/webp',
};

export function guessContentTypeFromFilename(filename: string): string {
  return CONTENT_TYPE_BY_EXT[getFileExtension(filename)] ?? 'application/octet-stream';
}

/**
 * Derives a human-readable filename from an S3 path / key: the last path
 * segment, URI-decoded. Falls back to `fallback` when the path is empty.
 */
export function deriveFilename(path: string | null, fallback: string): string {
  if (!path) return fallback;
  const last = path.split('/').filter(Boolean).pop();
  return last ? decodeURIComponent(last) : fallback;
}

/** Public Demo Builder files live in /public, not S3 / the /referral file route. */
export function isStaticPublicAttachmentUrl(url?: string | null): boolean {
  return typeof url === 'string' && url.startsWith('/demo-builder/');
}

/** Normalize resource URLs for use in src/href. App-relative paths are returned as-is. */
export function normalizeSignedResourceUrl(url: string): string {
  if (url.startsWith('/')) {
    return url;
  }
  try {
    return new URL(url).href;
  } catch {
    const queryIndex = url.indexOf('?');
    if (queryIndex === -1) {
      return url.replace(/ /g, '%20');
    }
    return `${url.slice(0, queryIndex).replace(/ /g, '%20')}${url.slice(queryIndex)}`;
  }
}
